export const pages = {
  // START - Registered pages in the router
  tools: {
    mainPage: '/tools',
    aiDashboard: '/tools/ai-dashboard',
    aiHomeworkSolver: '/tools/ai-homework-solver',
    aiHomeworkSolverView: '/tools/ai-homework-solver/view',
    aiDetector: '/tools/ai-detector',
    aiHumanizer: '/tools/ai-humanizer',
    aiWriterView: '/tools/ai-writer/view',
    aiRewriterView: '/tools/ai-rewriter/view',
    aiEssayWriter: '/tools/ai-essay-writer',
    aiEssayWriterView: '/tools/ai-essay-writer/view',
    plagiarismChecker: '/tools/plagiarism-checker',
  },
  // The Replit tools: the SPA loads their widget bundles (`replitToolRoutes`).
  replitTools: {
    toolsParaphraseText: '/tools/paraphrase-text',
    toolsGrammarChecker: '/tools/grammar-checker',
    toolsFactChecker: '/tools/fact-checker',
    toolsRewriteYourVoice: '/tools/ai-rewriter',
    toolsAiWriter: '/tools/ai-writer',
    toolsAiChat: '/tools/ai-chat',
    toolsSummarizeText: '/tools/summarize-text',
  },
  userProfile: {
    personalInfo: '/customer/ai-profile/personal-info',
    password: '/customer/ai-profile/password',
    support: '/customer/ai-profile/support',
    subscription: '/customer/ai-profile/subscription',
  },
  // END - Registered pages in the router

  // START - Not registered pages in the router
  parent: {
    pricing: '/pricing',
    expertSession: '/order-expert-session',
    expertHumanize: '/real-expert-help',
    customerOrders: '/customer/orders',
    logout: '/logout',
    // The host's way in for a guest: the home page with its login popup open
    needLogin: '/needlogin',
    aiDetector: '/ai-detector-tool',
    aiHumanize: '/ai-humanizer-tool',
    plagiarismChecker: '/plagiarism-checker-tool',
    removeAi: '/remove-ai',
    // Linked from the plans' legal texts.
    subscriptionPolicy: '/subscription-policy',
    paymentPolicy: '/payment-policy',
    terms: '/terms',
    privacy: '/privacy',

    // SEO Content Pages that are not registered in the router
    contentPages: {
      aiDetector: '/ai-detector',
      aiHumanize: '/ai-humanizer',
      plagiarismChecker: '/plagiarism-checker',
    },
  },
  // END - Not registered pages in the router

  // START - Registered pages in the router for test purposes
  testPages: {
    multiTool: '/test/multitool',
    wordCounter: '/test/word-counter',
    aiDetector: '/test/ai-detector',
    aiHumanize: '/test/ai-humanizer',
    removeAi: '/test/remove-ai',
    plagiarismChecker: '/test/plagiarism-checker',
    aiDetectorNew: '/test/ai-detector-new',
    aiChecker: '/test/ai-checker',
  },
  // END - Registered pages in the router for test purposes
} as const;

// The pages the SPA router serves; any other URL is a host page (full page load).
export const SPA_PAGES: readonly string[] = [
  ...Object.values(pages.tools),
  ...Object.values(pages.replitTools),
  ...Object.values(pages.userProfile),
];
